import OrderEventsOverview from './overview'
module.exports = {
  OrderEventsOverview
}



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/middlewares/orderevents/index.js